
import {
  SHOW_TYPE__CAROUSEL,
  SHOW_TYPE__TIME,
  SHOW_TYPE__IMAGE,
  SHOW_TYPE__PLACEHOLDER
} from "../../types"

import Carousel from "./Carousel";
import Time from "./Time";
import ImageChart from "./ImageChart";
import Placeholder from "./Placeholder";

export const controlNameMap = {
  [SHOW_TYPE__CAROUSEL]: "Carousel",
  [SHOW_TYPE__TIME]: "Time",
  [SHOW_TYPE__IMAGE]: "ImageChart",
  [SHOW_TYPE__PLACEHOLDER]: "Placeholder",
}

export default {
  [controlNameMap[SHOW_TYPE__CAROUSEL]]: Carousel,
  [controlNameMap[SHOW_TYPE__TIME]]: Time,
  [controlNameMap[SHOW_TYPE__IMAGE]]: ImageChart,
  [controlNameMap[SHOW_TYPE__PLACEHOLDER]]: Placeholder
}
